<div class="filter-container">
    <!-- Header Section -->
    <div class="filter-header">
      <div class="title-section">
        <div class="filter-title">{{ getFilterTitle() }}</div>
      </div>
      <div class="header-actions">
        <div class="reset-section" (click)="onReset()">
          <div class="reset-text">RESET</div>
        </div>
        <div class="close-section" (click)="onCancel()">
          <svg class="close-icon" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.75 4.25L4.25 12.75M4.25 4.25L12.75 12.75" stroke="#868C98" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="filter-content">
      <!-- Sidebar Navigation -->
      <div class="sidebar">
        <div class="navigation-section">
          <div class="nav-section">
            <!-- Main Divider -->
            <div class="main-divider">
              <div class="divider-text">MAIN</div>
            </div>

            <!-- Navigation Items -->
            <div class="nav-items">
              <div class="nav-item"
                   *ngFor="let section of filterSections"
                   [class.active]="selectedCategory === section.key"
                   (click)="selectCategory(section.key)">
                <svg class="nav-icon" width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.75 3.35767C16.9489 3.35767 17.1397 3.43668 17.2803 3.57734C17.421 3.71799 17.5 3.90875 17.5 4.10767V16.1077C17.5 16.3066 17.421 16.4973 17.2803 16.638C17.1397 16.7786 16.9489 16.8577 16.75 16.8577H3.25C3.05109 16.8577 2.86032 16.7786 2.71967 16.638C2.57902 16.4973 2.5 16.3066 2.5 16.1077V4.10767C2.5 3.90875 2.57902 3.71799 2.71967 3.57734C2.86032 3.43668 3.05109 3.35767 3.25 3.35767H16.75ZM9.25 10.8577H4V15.3577H9.25V10.8577ZM16 10.8577H10.75V15.3577H16V10.8577ZM9.25 4.85767H4V9.35767H9.25V4.85767ZM16 4.85767H10.75V9.35767H16V4.85767Z" [attr.fill]="selectedCategory === section.key ? '#FFF' : '#AEAEB2'"/>
                </svg>
                <div class="nav-content">
                  <div class="nav-text">{{ section.name }}</div>
                </div>
                <div class="nav-badge" *ngIf="section.count > 0">
                  <div class="badge-count">{{ section.count }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Applied Filters Panel -->
          <div class="applied-filters-section">
            <div class="applied-filters">
              <div class="applied-filters-header">
                <div class="applied-filters-title">Applied Filters</div>
              </div>
              <div class="applied-filters-content">
                <div class="applied-filter-item" *ngFor="let filter of getAppliedFilters()">{{ filter.name }}</div>
                <div class="no-filters" *ngIf="getAppliedFilters().length === 0">No filters applied</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Filter Content -->
      <div class="main-content">
        <div class="content-panel">
          <!-- Filter Content -->
          <div class="filter-content-area">
            <!-- Content Header -->
            <div class="content-header">
              <div class="header-content">
                <div class="content-title">{{ getContentTitle() }}</div>
                <div class="header-reset" (click)="onLocalReset()">
                  <div class="header-reset-text">RESET</div>
                </div>
              </div>
            </div>

            <div class="filter-scroll-container">
              <!-- Geography Filters -->
              <div *ngIf="selectedCategory === 'geography'" class="filter-panel">
                <app-geo-filter #geoFilter
                                [selectedGeography]="pendingFilterData.geography"
                                (selectionChange)="onGeographySelectionChange($event)"></app-geo-filter>
              </div>

              <!-- Company Filters -->
              <div *ngIf="selectedCategory === 'company'" class="filter-panel">
                <app-company-filters #companyFilters
                                     [selectedCompanies]="pendingFilterData.company.banners"
                                     (selectionChange)="onCompanySelectionChange($event)"></app-company-filters>
              </div>

              <!-- SQFT Filters -->
              <div *ngIf="selectedCategory === 'sqft'">
                <app-sqft-filters #sqftFilters
                                  [selectedRange]="pendingFilterData.sqft.range"
                                  [externalRangeMin]="sqftRangeMin"
                                  [externalRangeMax]="sqftRangeMax"
                                  (selectionChange)="onSqftSelectionChange($event)"></app-sqft-filters>
              </div>

              <!-- Sales Volume Filters -->
              <div *ngIf="selectedCategory === 'sales-volume'" class="sales-volume-section">
                <div class="range-header">
                  <div class="range-title">Sales Volume Range (weekly)</div>
                  <div class="range-display" *ngIf="!isLoadingRange">${{ formatNumber(minValue) }} - ${{ formatNumber(maxValue) }}</div>
                </div>

                <!-- Loading -->
                <div *ngIf="isLoadingRange" class="slider-loader">
                  <div class="circular-loader"></div>
                </div>

                <!-- Range Slider (only shown after API data loads) -->
                <ng-container *ngIf="!isLoadingRange">
                  <div class="range-slider-container">
                    <div class="slider-wrapper">
                      <div class="slider-track"></div>
                      <div class="slider-progress" [style.width.%]="getProgressWidth()" [style.left.%]="getProgressLeft()"></div>

                      <!-- Min Handle -->
                      <div class="slider-handle min-handle"
                           [style.left.%]="getMinHandlePosition()"
                           (mousedown)="startDrag('min', $event)">
                      </div>

                      <!-- Max Handle -->
                      <div class="slider-handle max-handle"
                           [style.left.%]="getMaxHandlePosition()"
                           (mousedown)="startDrag('max', $event)">
                      </div>

                      <!-- Range Labels -->
                      <div class="range-labels">
                        <div class="min-label">${{ formatNumber(rangeMin) }}</div>
                        <div class="max-label">${{ formatNumber(rangeMax) }}</div>
                      </div>
                    </div>
                  </div>

                  <!-- Min/Max Inputs -->
                  <div class="input-section">
                    <div class="input-group">
                      <div class="input-label">Min</div>
                      <div class="input-container">
                        <div class="input-wrapper" [class.error]="hasMinError">
                          <span class="input-prefix">$</span>
                          <input type="text"
                                 class="value-input"
                                 placeholder="3,900,000"
                                 [value]="formatInputValue(minInputValue)"
                                 (input)="onMinInputChange($event)"
                                 (blur)="validateInputs()">
                        </div>
                        <div class="error-message" *ngIf="hasMinError">
                          Value must be between ${{ formatNumber(rangeMin) }} and ${{ formatNumber(rangeMax) }}
                        </div>
                      </div>
                    </div>

                    <div class="input-group">
                      <div class="input-label">Max</div>
                      <div class="input-container">
                        <div class="input-wrapper" [class.error]="hasMaxError">
                          <span class="input-prefix">$</span>
                          <input type="text"
                                 class="value-input"
                                 placeholder="33,600,000"
                                 [value]="formatInputValue(maxInputValue)"
                                 (input)="onMaxInputChange($event)"
                                 (blur)="validateInputs()">
                        </div>
                        <div class="error-message" *ngIf="hasMaxError">
                          Max value must be greater than min value
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer Actions -->
    <div class="filter-footer">
      <button class="cancel-btn" (click)="onCancel()">
        <div class="btn-content">Cancel</div>
      </button>
      <button class="apply-btn" (click)="onApply()">
        <div class="btn-content">Apply</div>
      </button>
    </div>
</div>
